import React, { useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useFieldHighlight } from "../../context/ComponentesSlots";
import { useTourTarget } from "../../ui/Tour/tourStore";
import { agruparColorPickers } from "./agruparColorPickers";

const DURACAO = 2;
const SAIDA = [0.22, 1, 0.36, 1] as const;

const Field = ({ children, id }: { children: React.ReactNode; id?: string }) => {
    const pulso = useFieldHighlight(id);
    const semMovimento = useReducedMotion();
    const caixa = useRef<HTMLDivElement>(null);

    useTourTarget(id, caixa);

    return (
        <div ref={caixa} className="relative flex flex-col gap-3">
            {agruparColorPickers(children)}

            {pulso !== null && (
                <motion.span
                    key={pulso}
                    aria-hidden
                    className="pointer-events-none absolute -inset-x-1.5 -inset-y-1 rounded-lg bg-[#8346F9]/[0.06] ring-1 ring-[#8346F9]/25 ring-inset"
                    initial={{ opacity: 0, scale: semMovimento ? 1 : 1.015 }}
                    animate={{ opacity: [0, 1, 1, 0], scale: semMovimento ? 1 : [1.015, 1, 1, 1] }}
                    transition={{ duration: DURACAO, times: [0, 0.12, 0.62, 1], ease: SAIDA }}
                />
            )}
        </div>
    );
};

export default Field;
